<div class="section-wrap" [ngClass]="{'section-wrap_gray': shouldHaveGrayBackground}">
  <section class="explore-brain b-container">
    @if (callToActionText) {
      <h2 class="title explore-brain__title b-flow__text">
        {{ callToActionText }}
      </h2>
    }
    <button [routerLink]="callToActionButtonLink" class="b-button explore-brain__button">{{ callToActionButtonText }}</button>
  </section>
</div>
